import createVueApp from '@phoenix/createVueApp';
import ImageSlider from '@maison/components/organisms/slider/ImageSlider.vue';

document.querySelectorAll('.phoenix-image-slider').forEach((el) => {
  const app = createVueApp();
  app.component('ImageSlider', ImageSlider);
  app.mount(el);
});
